import { lighten } from 'polished';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const LinkMenu = styled(NavLink)`
  @media screen and (max-width: 1024px) {
    padding: 0;
    font-size: 14px;
    min-width: 85vw;
    padding: 5px 5px !important;
  }

  display: inline-block;
	font-size: 15px;
	font-weight: 400;
	position: relative;
	letter-spacing: 1px;
	font-family: 'Oswald';
	padding: 20px 15px !important;

	min-width: 100px;
	transition: all .5s;
	-webkit-transition: all .5s;
	-moz-transition: all .5s;
  color: #006747;

  &:hover {
    color: ${lighten(0.1, '#006747')};
  }

  span {
    display: flex;

    svg {
      margin-right: 5px;
    }
  }

  &.active {
    transition: all .5s;
    @media screen and (max-width: 1024px) {
      background-color: #006747;
      color: yellow;
      width: 100%;
      border: none;
    }
    
    color: ${lighten(0.1, '#006747')};
    border-bottom: 2px solid ${lighten(0.1, '#006747')};
  }
`;